import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Mapea las opciones de owl-carousel (responsive: { breakpoint: { items } })
// al formato de breakpoints de Swiper.
function mapBreakpoints(responsive) {
  if (!responsive) return undefined;
  const breakpoints = {};
  Object.keys(responsive).forEach((bp) => {
    const conf = responsive[bp] || {};
    breakpoints[bp] = {};
    if (conf.items !== undefined) breakpoints[bp].slidesPerView = conf.items;
    if (conf.margin !== undefined) breakpoints[bp].spaceBetween = conf.margin;
  });
  return breakpoints;
}

// Wrapper que conserva la API histórica (props.options en formato owl,
// onChangeIndex, onChangeRef) pero usa Swiper internamente (sin jQuery).
function OwlCarousel(props) {
  const { adClass = '', options = {}, children } = props;
  const swiperRef = useRef(null);

  const handleSwiper = (swiper) => {
    swiperRef.current = swiper;
    if (props.onChangeRef) {
      props.onChangeRef({ current: swiper });
    }
  };

  const handleSlideChange = (swiper) => {
    if (props.onChangeIndex) props.onChangeIndex(swiper.realIndex);
  };

  if (!children) return '';
  const slides = React.Children.toArray(children);
  if (slides.length === 0) return '';

  return (
    <Swiper
      className={`owl-carousel ${adClass}`}
      modules={[Navigation, Pagination, Autoplay]}
      slidesPerView={options.items ?? 1}
      spaceBetween={options.margin ?? 0}
      loop={options.loop ?? false}
      navigation={options.nav ?? false}
      pagination={options.dots ? { clickable: true } : false}
      autoplay={
        options.autoplay
          ? {
              delay: options.autoplayTimeout ?? 5000,
              disableOnInteraction: false,
            }
          : false
      }
      breakpoints={mapBreakpoints(options.responsive)}
      onSwiper={handleSwiper}
      onSlideChange={handleSlideChange}
    >
      {slides.map((child, i) => (
        <SwiperSlide key={i}>{child}</SwiperSlide>
      ))}
    </Swiper>
  );
}

export default React.memo(OwlCarousel);
